import { useTranslation } from 'react-i18next';

import { Loader, Typography, TYPOGRAPHY_SIZE } from '@thinknet-gmbh/platform-common-ui';
import { useGetOwnWorkingConditions } from 'src/hooks/working-conditions/get-own-working-conditions.hook';


import WorkingConditionsTable from 'src/components/employee/working-conditions-list/working-conditions-table/working-conditions-table.component';

import { ConditionTopBarWrapper, ViewContainer } from './working-conditions-list.styles';

const WorkingConditions = () => {
  const { t } = useTranslation(['common', 'employee', 'settings']);

  const { collection, loading } = useGetOwnWorkingConditions();

  if (loading) {
    return <Loader />;
  }

  return (
    <ViewContainer>
      <ConditionTopBarWrapper>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('employee:labels.workingConditions')}
        </Typography>
      </ConditionTopBarWrapper>
      <WorkingConditionsTable collection={collection} loading={loading} isOwnData />
    </ViewContainer>
  );
};

export default WorkingConditions;
